import { FC, memo } from 'react';
import { FileTypeEnum, FileType } from 'src/types';
import { MediaPreviewVideo } from './media-preview-video';

type Props = {
  isPreview: boolean;
  data?: FileType;
};

export const MediaPreviewItem: FC<Props> = memo(({ data, isPreview }) => {
  if (!data || !data.type) {
    return;
  }

  return data.type === FileTypeEnum.Image ? (
    <img src={data.url} />
  ) : (
    <MediaPreviewVideo src={data.url} isPreview={isPreview} />
  );
});
